import * as $runtime from "../runtime.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Restaumatic$dCart$dState$dState from "../Restaumatic.Cart.State.State/index.js";
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const savedAtIsSymbol = {reflectSymbol: () => "savedAt"};
const idIsSymbol = {reflectSymbol: () => "id"};
const contentsIsSymbol = {reflectSymbol: () => "contents"};
const encodeWithOptionsOther = {encodeWithOptions: v => Restaumatic$dCart$dState$dState.encodeState.encode};
const setJSONItem = /* #__PURE__ */ (() => Restaumatic$dServices$dStorage.setJSONItem({
  encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(savedAtIsSymbol)({
    encodeWithOptions: v => v2 => {
      if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
      if (v2.tag === "Just") { return v2._1; }
      $runtime.fail();
    }
  }))(idIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(contentsIsSymbol)(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
}))();
const decodeWithOptionsOther = {decodeWithOptions: v => Restaumatic$dCart$dState$dState.decodeState.decode};
const getJSONItem = /* #__PURE__ */ (() => Restaumatic$dServices$dStorage.getJSONItem({
  decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(savedAtIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.numberDecode.decode)
  })())(idIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())(contentsIsSymbol)(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
}))();
const stateIsSymbol = {reflectSymbol: () => "state"};
const getJSONItem1 = /* #__PURE__ */ (() => Restaumatic$dServices$dStorage.getJSONItem({
  decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(stateIsSymbol)(decodeWithOptionsOther)())(savedAtIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.numberDecode.decode
  })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
}))();
const setJSONItem2 = /* #__PURE__ */ (() => Restaumatic$dServices$dStorage.setJSONItem({
  encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(stateIsSymbol)(encodeWithOptionsOther))(savedAtIsSymbol)({
    encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
  }).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
}))();
const loadCartFromPreviousOrder$p = storage => uuid => {
  const $0 = getJSONItem(storage)("previousOrder");
  return () => {
    const v = $0();
    if (v.tag === "Just") {
      if (v._1.id === uuid) { return Data$dMaybe.$Maybe("Just", v._1.contents); }
      return Data$dMaybe.Nothing;
    }
    return Data$dMaybe.Nothing;
  };
};
const hasRecentlyOrdered = /* #__PURE__ */ (() => {
  const $0 = getJSONItem(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)("previousOrder");
  return () => {
    const v = $0();
    if (v.tag === "Just") {
      if (v._1.savedAt.tag === "Just") {
        const now = Effect$dNow.now();
        return now <= v._1.savedAt._1 + 10800000.0;
      }
      return false;
    }
    return false;
  };
})();
const loadCartState = storage => () => {
  const now = Effect$dNow.now();
  const v = getJSONItem1(storage)("cart")();
  if (v.tag === "Nothing") { return Data$dMaybe.Nothing; }
  if (v.tag === "Just") {
    const age = Data$dInt.unsafeClamp(Data$dNumber.floor((now - v._1.savedAt) / 1000.0));
    if (now <= v._1.savedAt + 1800000.0) {
      Effect$dConsole.log("Cart loaded, age=" + Data$dShow.showIntImpl(age) + " seconds")();
      return Data$dMaybe.$Maybe("Just", v._1.state);
    }
    Effect$dConsole.log("Discarding stale cart, age=" + Data$dShow.showIntImpl(age) + " seconds")();
    return Data$dMaybe.Nothing;
  }
  $runtime.fail();
};
const moveCartToPreviousOrder = uuid => {
  const $0 = loadCartState(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback);
  return () => {
    const m_state = $0();
    if (m_state.tag === "Just") {
      const now = Effect$dNow.now();
      setJSONItem(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)("previousOrder")({
        contents: m_state._1,
        id: uuid,
        savedAt: Data$dMaybe.$Maybe("Just", now)
      })();
      return Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback._2("cart")(Foreign$dInternal$dStringify.unsafeStringify(Foreign$dObject.empty))();
    }
  };
};
const storeCartState = storage => state => () => {
  const now = Effect$dNow.now();
  return setJSONItem2(storage)("cart")({state, savedAt: now})();
};
const loadCartFromPreviousOrder = uuid => {
  const $0 = loadCartFromPreviousOrder$p(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)(uuid);
  return () => {
    const m_state = $0();
    if (m_state.tag === "Just") {
      const now = Effect$dNow.now();
      return setJSONItem2(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)("cart")({state: m_state._1, savedAt: now})();
    }
  };
};
export {
  contentsIsSymbol,
  decodeWithOptionsOther,
  encodeWithOptionsOther,
  getJSONItem,
  getJSONItem1,
  hasRecentlyOrdered,
  idIsSymbol,
  loadCartFromPreviousOrder,
  loadCartFromPreviousOrder$p,
  loadCartState,
  moveCartToPreviousOrder,
  savedAtIsSymbol,
  setJSONItem,
  setJSONItem2,
  stateIsSymbol,
  storeCartState
};
